export default __webpack_public_path__ + "static/media/opensea.694666a8.svg";